import { downloadCSV } from "react-admin";
import { get } from "lodash";
import jsonExport from "jsonexport/dist";

const exporter = (projects, translate) => {
  const columnName = (name, args) =>
    translate(`resources.projects.fields.${name}`, args);

  const projectsToExport = projects.map((project) => ({
    [columnName("code")]: get(project, "code"),
    [columnName("title")]: get(project, "title"),
  }));
  jsonExport(
    projectsToExport,
    {
      rowDelimiter: ";",
      headers: [columnName("code"), columnName("title")],
    },
    (err, csv) =>
      downloadCSV(
        "\uFEFF" + csv,
        translate("resources.projects.name", { smart_count: 2 })
      )
  );
};

export default exporter;
